import React, { useRef, useEffect, useMemo, forwardRef } from "react";
import { FlatList, Platform, View } from "react-native";

const CustomFlatList = ({
  data,
  renderItem,
  keyExtractor,
  customHeaderContainerStyle,
  contentContainerStyle,
  ListHeaderComponent,
  ListFooterComponent,
  ListEmptyComponent,
  horizontal = false,
  showsVerticalScrollIndicator = false,
  showsHorizontalScrollIndicator = false,
  initialNumToRender=10,
  maxToRenderPerBatch=10,
  windowSize=10,
  ...restProps
}, ref) => {

  const customContentContainerStyle = useMemo(() => {
    return Array.isArray(contentContainerStyle) ? Object.assign({}, ...contentContainerStyle) : contentContainerStyle || {};
  }, [contentContainerStyle]);

  return (
    <FlatList
      ref={ref}
      data={data}
      renderItem={renderItem}
      keyExtractor={keyExtractor}
      initialNumToRender={initialNumToRender}
      maxToRenderPerBatch={maxToRenderPerBatch}
      windowSize={windowSize}
      ListHeaderComponentStyle={customHeaderContainerStyle}
      contentContainerStyle={customContentContainerStyle}
      ListHeaderComponent={ListHeaderComponent}
      ListEmptyComponent={ListEmptyComponent}
      ListFooterComponent={ListFooterComponent}
      showsVerticalScrollIndicator={showsVerticalScrollIndicator}
      horizontal={horizontal}
      showsHorizontalScrollIndicator={showsHorizontalScrollIndicator}
      {...restProps}
    />
  );
};

export default forwardRef(CustomFlatList);